import ko from 'knockout';

export default function ViewModel(options = {}) {
  this.suggestedAdgroup = options.SuggestedAdGroup;
  this.gridData = options.SuggestedAdGroup.Suggestions;
  this.adgroups = ko.observableArray(options.AdGroups);
}
